// Module
var code = "<div ui=\"ui.navigation\"></div> <section class=\"templates-container\"> <div class=\"templates-container__sidebar\"> <div ui=\"ui.filter\"></div> <div ui=\"ui.results\"></div> </div> <div ui=\"ui.browser\" class=\"templates-container__browser\"></div> </section> ";
// Exports
var _module_exports = code;;
var path = 'Templates/Templates.ng.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;